export var spacing_xs = '8px';
export var spacing_sm = '12px';
export var spacing_md = '16px';
export var spacing_lg = '24px';
export var spacing_xl = '32px';
export var spacing_xxl = '36px';
//# sourceMappingURL=spacing.js.map